export const TEXT_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.TextElement';
